module.exports = __webpack_public_path__ + "media/images/gallery/5s-7061825a2387aa17ac7ab2c0690b6e4c.jpg";